import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, Fragment as _Fragment, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1146dbe0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "formContainer",
  class: "container page-container"
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-12 col-lg-12" }
const _hoisted_4 = { class: "font-lead" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-12 col-lg-12" }
const _hoisted_7 = {
  class: "tabnav",
  role: "tablist",
  id: "tabs"
}
const _hoisted_8 = {
  "aria-controls": "tabpanel_eval",
  id: "tab_eval",
  class: "tabnav-item",
  role: "tab",
  "aria-selected": "true"
}
const _hoisted_9 = {
  class: "show-sort-menu tabnav-panel",
  "aria-hidden": "false",
  role: "tabpanel",
  tabindex: "0",
  id: "tabpanel_eval",
  "aria-labelledby": "tab_eval"
}
const _hoisted_10 = { class: "form-group-radio" }
const _hoisted_11 = {
  for: 'radio-tilbud',
  id: 'tco_label_radio-tilbud'
}
const _hoisted_12 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_13 = {
  for: 'radio-produkt',
  id: 'tco_label_radio-produkt'
}
const _hoisted_14 = {
  class: "overflow-menu overflow-menu--sort overflow-menu--open-right",
  id: "sorting-overflow-menu"
}
const _hoisted_15 = {
  class: "button-overflow-menu",
  "data-js-target": "sorting-overflow-menu-panel",
  "aria-haspopup": "true",
  "aria-expanded": "false"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "icon-svg",
  "aria-hidden": "true",
  focusable: "false"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#sort-default" })
], -1))
const _hoisted_17 = { class: "selected-value" }
const _hoisted_18 = {
  class: "overflow-menu-inner collapsed",
  id: "sorting-overflow-menu-panel",
  "aria-hidden": "true"
}
const _hoisted_19 = {
  role: "menuitem",
  "aria-selected": "true"
}
const _hoisted_20 = { id: "low-score" }
const _hoisted_21 = { role: "menuitem" }
const _hoisted_22 = { id: "high-score" }
const _hoisted_23 = { role: "menuitem" }
const _hoisted_24 = { id: "low-co2" }
const _hoisted_25 = { role: "menuitem" }
const _hoisted_26 = { id: "high-co2" }
const _hoisted_27 = { role: "menuitem" }
const _hoisted_28 = { id: "name-asc" }
const _hoisted_29 = { role: "menuitem" }
const _hoisted_30 = { id: "name-desc" }
const _hoisted_31 = {
  key: 1,
  type: "button",
  class: "button button-unstyled button-underline",
  "data-micromodal-trigger": 'print-modal'
}
const _hoisted_32 = { key: 3 }
const _hoisted_33 = {
  "aria-controls": "tabpanel_top",
  id: "tab_top",
  class: "tabnav-item",
  role: "tab",
  "aria-selected": "false"
}
const _hoisted_34 = {
  class: "tabnav-panel",
  "aria-hidden": "true",
  role: "tabpanel",
  tabindex: "0",
  id: "tabpanel_top",
  "aria-labelledby": "tab_top"
}
const _hoisted_35 = {
  key: 0,
  class: "top-5-box"
}
const _hoisted_36 = { class: "top-5-label pt-5 pb-2 pl-4" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "ml-4 mr-4" }, null, -1))
const _hoisted_38 = { class: "ml-4 mr-4" }
const _hoisted_39 = {
  class: "table table--borderless table--compact",
  id: "total-table"
}
const _hoisted_40 = {
  key: 1,
  class: "top-5-box"
}
const _hoisted_41 = { class: "top-5-label pt-5 pb-2 pl-4" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "ml-4 mr-4" }, null, -1))
const _hoisted_43 = { class: "ml-4 mr-4" }
const _hoisted_44 = {
  class: "table table--borderless table--compact",
  id: "env-table"
}
const _hoisted_45 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_KlarTekst = _resolveComponent("KlarTekst")!
  const _component_OGEvaluateEntry = _resolveComponent("OGEvaluateEntry")!
  const _component_OGEvaluatePrintModal = _resolveComponent("OGEvaluatePrintModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h2", null, [
          _createVNode(_component_KlarTekst, { "tekst-noegle": "tco.evaluering.titel" })
        ]),
        _createElementVNode("p", _hoisted_4, [
          _createVNode(_component_KlarTekst, { "tekst-noegle": "tco.evaluering.titel.sub" })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("button", _hoisted_8, [
            _createElementVNode("span", null, [
              _createVNode(_component_KlarTekst, { "tekst-noegle": "tco.evaluering.tab-0.titel" })
            ])
          ]),
          _createElementVNode("section", _hoisted_9, [
            _createElementVNode("h5", null, [
              _createVNode(_component_KlarTekst, { "tekst-noegle": "tco.evaluering.sorter.tilbud-produkt.overskrift" })
            ]),
            _createElementVNode("div", _hoisted_10, [
              _withDirectives(_createElementVNode("input", {
                id: 'radio-tilbud',
                type: "radio",
                name: 'radio-tilbud-produkt',
                value: 'offer',
                class: "form-radio radio-large",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((this.sortOfferProduct) = $event)),
                onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.sortRadio($event))),
                "aria-controls": 'radio-tilbud',
                "aria-expanded": "false"
              }, null, 544), [
                [_vModelRadio, this.sortOfferProduct]
              ]),
              _createElementVNode("label", _hoisted_11, [
                _createVNode(_component_KlarTekst, { "tekst-noegle": "tco.evaluering.sorter.tilbud.label" })
              ]),
              _hoisted_12,
              _withDirectives(_createElementVNode("input", {
                id: 'radio-produkt',
                type: "radio",
                name: 'radio-tilbud-produkt',
                value: 'product',
                class: "form-radio radio-large",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((this.sortOfferProduct) = $event)),
                onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.sortRadio($event))),
                "aria-controls": 'radio-produkt',
                "aria-expanded": "false"
              }, null, 544), [
                [_vModelRadio, this.sortOfferProduct]
              ]),
              _createElementVNode("label", _hoisted_13, [
                _createVNode(_component_KlarTekst, { "tekst-noegle": "tco.evaluering.sorter.produkt.label" })
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("button", _hoisted_15, [
                _hoisted_16,
                _createVNode(_component_KlarTekst, { "tekst-noegle": "tco.evaluering.sorter.label" }),
                _createElementVNode("span", _hoisted_17, [
                  _createVNode(_component_KlarTekst, { "tekst-noegle": "tco.evaluering.sorter.værdi.laveste-total" })
                ])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("ul", {
                  class: "overflow-list",
                  role: "menu",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.sort($event)))
                }, [
                  _createElementVNode("li", _hoisted_19, [
                    _createElementVNode("button", _hoisted_20, [
                      _createVNode(_component_KlarTekst, { "tekst-noegle": "tco.evaluering.sorter.værdi.laveste-total" })
                    ])
                  ]),
                  _createElementVNode("li", _hoisted_21, [
                    _createElementVNode("button", _hoisted_22, [
                      _createVNode(_component_KlarTekst, { "tekst-noegle": "tco.evaluering.sorter.værdi.højeste-total" })
                    ])
                  ]),
                  _createElementVNode("li", _hoisted_23, [
                    _createElementVNode("button", _hoisted_24, [
                      _createVNode(_component_KlarTekst, { "tekst-noegle": "tco.evaluering.sorter.værdi.laveste-co2" })
                    ])
                  ]),
                  _createElementVNode("li", _hoisted_25, [
                    _createElementVNode("button", _hoisted_26, [
                      _createVNode(_component_KlarTekst, { "tekst-noegle": "tco.evaluering.sorter.værdi.højeste-co2" })
                    ])
                  ]),
                  (this.sortOfferProduct === 'offer')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("li", _hoisted_27, [
                          _createElementVNode("button", _hoisted_28, [
                            _createVNode(_component_KlarTekst, { "tekst-noegle": "tco.evaluering.sorter.værdi.navn-a-å" })
                          ])
                        ]),
                        _createElementVNode("li", _hoisted_29, [
                          _createElementVNode("button", _hoisted_30, [
                            _createVNode(_component_KlarTekst, { "tekst-noegle": "tco.evaluering.sorter.værdi.navn-å-a" })
                          ])
                        ])
                      ], 64))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            (this.evaluation.companies.length > 0)
              ? (_openBlock(), _createBlock(_component_OGEvaluateEntry, {
                  key: 0,
                  evaluation: this.evaluation
                }, null, 8, ["evaluation"]))
              : _createCommentVNode("", true),
            (this.evaluation.companies.length > 0)
              ? (_openBlock(), _createElementBlock("button", _hoisted_31, [
                  _createVNode(_component_KlarTekst, { tekstNoegle: "tco.evaluering.download-alle-tilbud.label" })
                ]))
              : _createCommentVNode("", true),
            (this.evaluation.companies.length > 0)
              ? (_openBlock(), _createBlock(_component_OGEvaluatePrintModal, {
                  key: 2,
                  ogId: this.ogId,
                  sort: this.sortValue,
                  sortOfferProduct: this.sortOfferProduct,
                  modalId: "print-modal"
                }, null, 8, ["ogId", "sort", "sortOfferProduct"]))
              : _createCommentVNode("", true),
            (this.evaluation.topEnvProducts.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                  _createVNode(_component_KlarTekst, { "tekst-noegle": "tco.evaluering.ingen-tilbud-findes-endnu.label" })
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("button", _hoisted_33, [
            _createElementVNode("span", null, [
              _createVNode(_component_KlarTekst, { "tekst-noegle": "tco.evaluering.tab-1.titel" })
            ])
          ]),
          _createElementVNode("section", _hoisted_34, [
            (this.evaluation.topTotalProducts.length > 0 )
              ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                  _createElementVNode("p", _hoisted_36, [
                    _createVNode(_component_KlarTekst, { "tekst-noegle": "tco.evaluering.titel.0" })
                  ]),
                  _hoisted_37,
                  _createElementVNode("div", _hoisted_38, [
                    _createElementVNode("table", _hoisted_39, [
                      _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("th", null, [
                            _createVNode(_component_KlarTekst, { "tekst-noegle": "tco.evaluering.subtitel.tabel0.0" })
                          ]),
                          _createElementVNode("th", null, [
                            _createVNode(_component_KlarTekst, { "tekst-noegle": "tco.evaluering.subtitel.tabel0.1" })
                          ]),
                          _createElementVNode("th", null, [
                            _createVNode(_component_KlarTekst, { "tekst-noegle": "tco.evaluering.subtitel.tabel0.2" })
                          ]),
                          _createElementVNode("th", null, [
                            _createVNode(_component_KlarTekst, { "tekst-noegle": "tco.evaluering.subtitel.tabel0.3" })
                          ]),
                          _createElementVNode("th", null, [
                            _createVNode(_component_KlarTekst, { "tekst-noegle": "tco.evaluering.subtitel.tabel0.4" })
                          ]),
                          _createElementVNode("th", null, [
                            _createVNode(_component_KlarTekst, { "tekst-noegle": "tco.evaluering.subtitel.tabel0.5" })
                          ])
                        ])
                      ]),
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.evaluation.topTotalProducts, (v, index) => {
                          return (_openBlock(), _createElementBlock("tr", { key: v }, [
                            _createElementVNode("td", null, [
                              _createTextVNode(_toDisplayString(index === 0 ? '' : index + 1 + '. '), 1),
                              _createVNode(_component_KlarTekst, { "tekst-noegle": "tco.evaluering.laveste.label" })
                            ]),
                            _createElementVNode("td", null, _toDisplayString(_ctx.formatNumeric(v.tcoTotalsTotalAmount, '')), 1),
                            _createElementVNode("td", null, _toDisplayString(_ctx.formatNumeric(v.tcoTotalsTotalPerYearAmount, 'kr./år')), 1),
                            _createElementVNode("td", null, _toDisplayString(v.sellersItemIdentification), 1),
                            _createElementVNode("td", null, _toDisplayString(v.name), 1),
                            _createElementVNode("td", null, _toDisplayString(v.companyName), 1)
                          ]))
                        }), 128))
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (this.evaluation.topEnvProducts.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                  _createElementVNode("p", _hoisted_41, [
                    _createVNode(_component_KlarTekst, { "tekst-noegle": "tco.evaluering.titel1" })
                  ]),
                  _hoisted_42,
                  _createElementVNode("div", _hoisted_43, [
                    _createElementVNode("table", _hoisted_44, [
                      _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("th", null, [
                            _createVNode(_component_KlarTekst, { "tekst-noegle": "tco.evaluering.subtitel.tabel1.0" })
                          ]),
                          _createElementVNode("th", null, [
                            _createVNode(_component_KlarTekst, { "tekst-noegle": "tco.evaluering.subtitel.tabel1.1" })
                          ]),
                          _createElementVNode("th", null, [
                            _createVNode(_component_KlarTekst, { "tekst-noegle": "tco.evaluering.subtitel.tabel1.2" })
                          ]),
                          _createElementVNode("th", null, [
                            _createVNode(_component_KlarTekst, { "tekst-noegle": "tco.evaluering.subtitel.tabel1.3" })
                          ]),
                          _createElementVNode("th", null, [
                            _createVNode(_component_KlarTekst, { "tekst-noegle": "tco.evaluering.subtitel.tabel1.4" })
                          ]),
                          _createElementVNode("th", null, [
                            _createVNode(_component_KlarTekst, { "tekst-noegle": "tco.evaluering.subtitel.tabel1.5" })
                          ])
                        ])
                      ]),
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.evaluation.topEnvProducts, (v, index) => {
                          return (_openBlock(), _createElementBlock("tr", { key: v }, [
                            _createElementVNode("td", null, [
                              _createTextVNode(_toDisplayString(index === 0 ? '' : index + 1 + '. '), 1),
                              _createVNode(_component_KlarTekst, { "tekst-noegle": "tco.evaluering.laveste.label" })
                            ]),
                            _createElementVNode("td", null, _toDisplayString(_ctx.formatNumeric(v.tcoTotalsCO2EmissionQuantity, '', true)), 1),
                            _createElementVNode("td", null, _toDisplayString(_ctx.formatNumeric(v.tcoTotalsTotalPerYearAmount, 'kr./år')), 1),
                            _createElementVNode("td", null, _toDisplayString(v.orderId), 1),
                            _createElementVNode("td", null, _toDisplayString(v.name), 1),
                            _createElementVNode("td", null, _toDisplayString(v.companyName), 1)
                          ]))
                        }), 128))
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (this.evaluation.topEnvProducts.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                  _createVNode(_component_KlarTekst, { "tekst-noegle": "tco.evaluering.ingen-tilbud-findes-endnu.label" })
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ]))
}